function PrescribedDrugVO(id, p2DrugId, p2DrugPackageId, pharmindexDrugPackageId, author, prescription, drug, count, drugPaymentType, dosageDescription, additionalNotes, recipe,
                          dosageTypes, deleted, deletionReasonType, deletionReason, visitCard, patient, dateFrom, dateTo,
                          alreadyPrinted, visit, modifiedBy, wholeYear, treatmentDurationInDays) {
    this.id = id;
    // these 2 properties (p2DrugId, p2DrugPackageId) below have been added to meet the new requirements at the same time for backward compatibility.
    // In this situation 2 separate models should be created correctly but this generated a huge amount of work and a lot of code in controllers.
    this.p2DrugId = p2DrugId;
    this.p2DrugPackageId = p2DrugPackageId;
    this.pharmindexDrugPackageId = pharmindexDrugPackageId;

    this.author = author;
    this.prescription = prescription;
    this.drug = drug;
    this.count = count;
    this.drugPaymentType = drugPaymentType;
    this.dosageDescription = dosageDescription;
    this.additionalNotes = additionalNotes;
    this.recipe = recipe;
    this.dosageTypes = dosageTypes;
    this.visitCard = visitCard;
    this.patient = patient;
    this.deleted = deleted;
    this.deletionReasonType = deletionReasonType;
    this.deletionReason = deletionReason;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.alreadyPrinted = alreadyPrinted;
    this.visit = visit;
    this.modifiedBy = modifiedBy;
    this.wholeYear = wholeYear;
    this.treatmentDurationInDays = treatmentDurationInDays;

    var _typeContext = {
        dateFrom: Date,
        dateTo: Date,
        prescription: PrescriptionVO,
        drug: DrugVO,
        patient: PatientVO,
        author: UserVO,
        visitCard: VisitCardVO,
        visit: VisitVO,
        modifiedBy: UserVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
